// extracted by mini-css-extract-plugin
export default {"chooseProductsStep":"chooseProductsStep_chooseProductsStep__abkSk","productList":"chooseProductsStep_productList__mpPgD","buttonArea":"chooseProductsStep_buttonArea__JaOMd"};